<template>
  <div :style="`position: ${position === 'relative' ? 'absolute' : 'unset'};`">
    <v-color-picker
      v-model="color"
      :style="`position: ${position}; top: ${top + topOffset}px; right: ${right + rightOffset}px;`"
      hide-mode-switch
      elevation="15"
      mode="hexa"
      @update:color="pickColor"
    ></v-color-picker>
    <v-btn
      :style="`position: ${position}; top: ${top}px; right: ${right}px;`"
      dark
      x-small
      color="#000000"
      @click="pickColor('black')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 20}px; right: ${position === 'relative' ? right + 36 : right}px;`"
      dark
      x-small
      color="#696969"
      @click="pickColor('dimgrey')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 40}px; right: ${position === 'relative' ? right + 72 : right}px;`"
      dark
      x-small
      color="#FF0000"
      @click="pickColor('red')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 60}px; right: ${position === 'relative' ? right + 108 : right}px;`"
      dark
      x-small
      color="#008B00"
      @click="pickColor('green4')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 80}px; right: ${position === 'relative' ? right + 144 : right}px;`"
      dark
      x-small
      color="#1E90FF"
      @click="pickColor('dodgerblue')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 100}px; right: ${position === 'relative' ? right + 180 : right}px;`"
      dark
      x-small
      color="#FFFF00"
      @click="pickColor('yellow')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 120}px; right: ${position === 'relative' ? right + 216 : right}px;`"
      dark
      x-small
      color="#FF8C00"
      @click="pickColor('darkorange')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 140}px; right: ${position === 'relative' ? right + 252 : right}px;`"
      dark
      x-small
      color="#EE82EE"
      @click="pickColor('violet')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 160}px; right: ${position === 'relative' ? right +288 : right}px;`"
      dark
      x-small
      color="#9400D3"
      @click="pickColor('darkviolet')"
    ></v-btn>
    <v-btn
      :style="`position: ${position}; top: ${top + 270}px; right: ${position === 'relative' ? right + 324 : right - 10}px;`"
      dark
      x-small
      @click="pickColor('close')"
    >
      关闭
    </v-btn>
  </div>
</template>

<script>
export default {
  data: () => ({
    color: '#FF0000'
  }),
  props: {
    deductionColor: String,
    position: String,
    top: Number,
    topOffset: {
      type: Number,
      default: 0
    },
    right: Number,
    rightOffset: {
      type: Number,
      default: 0
    }
  },
  watch: {
    deductionColor(color) {
      this.color = color;
    }
  },
  methods: {
    pickColor(color) {
      switch (color) {
        case 'black':
          this.color = '#000000';
          break;
        case 'dimgrey':
          this.color = '#696969';
          break;
        case 'red':
          this.color = '#FF0000';
          break;
        case 'green4':
          this.color = '#008B00';
          break;
        case 'dodgerblue':
          this.color = '#1E90FF';
          break;
        case 'yellow':
          this.color = '#FFFF00';
          break;
        case 'darkorange':
          this.color = '#FF8C00';
          break;
        case 'violet':
          this.color = '#EE82EE';
          break;
        case 'darkviolet':
          this.color = '#9400D3';
          break;
        case 'close':
          this.color = 'close';
          break;
      }

      this.$emit('pickColor', this.color);
    },
  },
  mounted() {
    if (this.deductionColor) this.color = this.deductionColor;
  }
}
</script>
